import type {
  ChangeLanguageDataToBackend,
  PersonalDataToBackend,
  ProfileFromBackend,
} from './types';

import { URL } from '../../../constants';
import { httpApiService, ServiceConfig } from '../../../utils/create-http-api-service';
import { defaultRequestService } from '../../../utils/default-request-service';

// ---

export const getProfile = (config: ServiceConfig) => {
  type AdapterProps = { response: ProfileFromBackend };

  return defaultRequestService<AdapterProps>(URL.PROFILE, config.instance.get);
};

export const savePersonalData = (requestData: PersonalDataToBackend) => {
  type AdapterProps = { request: typeof requestData };

  return defaultRequestService<AdapterProps>(URL.SAVE_PROFILE_NAME, httpApiService.patch, {
    requestData,
  });
};

export const changeLanguage = (requestData: ChangeLanguageDataToBackend) => {
  type AdapterProps = { request: typeof requestData };

  return defaultRequestService<AdapterProps>(URL.CLIENT_PROFILE_LANGUAGE, httpApiService.patch, {
    requestData,
  });
};
